import { useParams } from 'react-router'
import { api } from 'src/api/root'
import Loader from 'src/components/atoms/Loader'
import useAuth from 'src/enviroment/hooks/useAuth'
import AuthWrapper from 'src/enviroment/layouts/auth-wrapper'
import OauthConsentExpired from 'src/templates/auth/oauth-consent/OauthConsentExpired'
import OauthConsentTemplate from 'src/templates/auth/oauth-consent/OauthConsentTemplate'

const goTo = ({ redirectTo }: { redirectTo: string }) => window.location.assign(redirectTo)

export default function OauthConsentPage() {
  const { uid = '' } = useParams()
  const { user } = useAuth()
  const { data: interaction, isError } = api.oauth.interaction.useQuery(uid)
  const consentMutation = api.oauth.consent.useMutation({ onSuccess: goTo })
  const abortMutation = api.oauth.abort.useMutation({ onSuccess: goTo })
  // Stays disabled after success: the interaction is gone while the browser is still navigating away.
  const isLeaving = [consentMutation, abortMutation].some((m) => m.isPending || m.isSuccess)

  if (isError) {
    return <OauthConsentExpired />
  }

  if (!interaction) {
    return (
      <AuthWrapper>
        <Loader className="text-light-green-300" />
      </AuthWrapper>
    )
  }

  return (
    <OauthConsentTemplate
      {...interaction}
      email={user?.email}
      isAllowing={consentMutation.isPending}
      isDenying={abortMutation.isPending}
      isLeaving={isLeaving}
      onAllow={() => consentMutation.mutate(uid)}
      onDeny={() => abortMutation.mutate(uid)}
    />
  )
}
